import _objectSpread from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.number.constructor.js";
/**
 * 文本框组件，继承Base
 * @module $ui/components/my-date-picker
 */

import { DatePicker, TimePicker, TimeSelect } from 'element-ui';
import Base from '../Base';
export default {
  name: 'MyDatePicker',
  mixins: [Base],
  components: {
    DatePicker: DatePicker,
    TimePicker: TimePicker,
    TimeSelect: TimeSelect
  },
  props: {
    value: [Date, String, Number, Array],
    mode: {
      type: String,
      default: 'date',
      validator: function validator(val) {
        return ['time', 'timeSelect', 'date', 'dateTime', 'month'].includes(val);
      }
    }
  },
  methods: {},
  render: function render() {
    var _this = this;
    var h = arguments[0];
    var vnode = null;
    if (this.mode === 'date') {
      vnode = h(DatePicker, {
        "ref": 'comp',
        "class": 'my-date-picker',
        "props": _objectSpread({}, this.innerProps),
        "on": _objectSpread({}, this.$listeners),
        "attrs": _objectSpread({}, this.innerProps),
        "model": {
          value: _this.fieldValue,
          callback: function callback($$v) {
            _this.fieldValue = $$v;
          }
        }
      });
    } else if (this.mode === 'dateTime') {
      vnode = h(DatePicker, {
        "ref": 'comp',
        "class": 'my-date-picker',
        "props": _objectSpread({}, this.innerProps),
        "on": _objectSpread({}, this.$listeners),
        "attrs": _objectSpread(_objectSpread({}, this.innerProps), {}, {
          "type": 'datetime'
        }),
        "model": {
          value: _this.fieldValue,
          callback: function callback($$v) {
            _this.fieldValue = $$v;
          }
        }
      });
    } else if (this.mode === 'month') {
      vnode = h(DatePicker, {
        "ref": 'comp',
        "class": 'my-date-picker',
        "props": _objectSpread({}, this.innerProps),
        "on": _objectSpread({}, this.$listeners),
        "attrs": _objectSpread(_objectSpread({}, this.innerProps), {}, {
          "type": 'month'
        }),
        "model": {
          value: _this.fieldValue,
          callback: function callback($$v) {
            _this.fieldValue = $$v;
          }
        }
      });
    } else if (this.mode === 'time') {
      vnode = h(TimePicker, {
        "ref": 'comp',
        "class": 'my-date-picker',
        "props": _objectSpread({}, this.innerProps),
        "on": _objectSpread({}, this.$listeners),
        "attrs": _objectSpread({}, this.innerProps),
        "model": {
          value: _this.fieldValue,
          callback: function callback($$v) {
            _this.fieldValue = $$v;
          }
        }
      });
    } else if (this.mode === 'timeSelect') {
      vnode = h(TimeSelect, {
        "ref": 'comp',
        "class": 'my-date-picker',
        "props": _objectSpread({}, this.innerProps),
        "on": _objectSpread({}, this.$listeners),
        "attrs": _objectSpread({}, this.innerProps),
        "model": {
          value: _this.fieldValue,
          callback: function callback($$v) {
            _this.fieldValue = $$v;
          }
        }
      });
    }
    return this.renderComponent(vnode);
  },
  mounted: function mounted() {
    this.extendMethods(this.$refs.comp, ['focus']);
  }
};